module.exports = __webpack_public_path__ + "static/media/logoSmall.10474eb8.svg";